import React from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import TicketsManager from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	chatContainer: {
		flex: 1,
		padding: 0,
		height: "calc(100vh - 50px)", // Ajustado para descontar header/navbar
		overflow: "hidden",
		display: "flex",
		flexDirection: "column",
		position: "relative",
		// iPad/tablet Safari: 100vh pode ser maior que o viewport visível;
		// position:absolute com inset:0 garante altura correta.
		"@media (pointer: coarse) and (min-width: 600px) and (min-height: 600px)": {
			position: "absolute",
			inset: 0,
			height: "auto",
		},
	},

	chatPapper: {
		display: "flex",
		height: "100%",
		flex: 1,
	},

	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflowY: "hidden",
		// Controle individual de cada espaçamento:
		paddingTop: theme.spacing(1),    // Espaçamento superior
		paddingRight: theme.spacing(0),   // SEM espaçamento direito (cola no Ticket)
		paddingBottom: theme.spacing(1),  // Espaçamento inferior
		paddingLeft: theme.spacing(1),    // Espaçamento esquerdo
		// On a tablet every box keeps the same 12px from the bar and the screen's edges.
		'html[data-page-header="tablet"] &': { paddingTop: 12, paddingBottom: 12, paddingLeft: 12 },
		// iPad/tablet: mantém a proporção original sem zoom global.
		"@media (pointer: coarse) and (min-width: 600px) and (min-height: 600px)": {
			flexBasis: "38% !important",
			maxWidth: "38% !important",
		},
	},

	messagesWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		// Controle individual de cada espaçamento:
		paddingTop: theme.spacing(1),    // Espaçamento superior
		paddingRight: theme.spacing(1),   // Espaçamento direito
		paddingBottom: theme.spacing(1),  // Espaçamento inferior
		paddingLeft: theme.spacing(0),    // SEM espaçamento esquerdo (cola no TicketsManager)
		'html[data-page-header="tablet"] &': { paddingTop: 12, paddingBottom: 12, paddingRight: 12 },
		// iPad/tablet: complemento da largura original da lista.
		"@media (pointer: coarse) and (min-width: 600px) and (min-height: 600px)": {
			flexBasis: "62% !important",
			maxWidth: "62% !important",
		},
	},

	welcomeMsg: {
		backgroundColor: theme.palette.boxticket,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
		border: theme.neoUI.effects.contour.main,
		boxShadow: theme.neoUI.effects.glow.main,

		// Controle individual de cada canto:
		borderTopLeftRadius: 0,     // Canto superior esquerdo
		borderTopRightRadius: 12,     // Canto superior direito
		borderBottomLeftRadius: 0,   // Canto inferior esquerdo
		borderBottomRightRadius: 12,  // Canto inferior direito
	},
}));

const TicketsCustom = () => {
	const classes = useStyles();
	const { ticketId } = useParams();

	return (
		<div className={classes.chatContainer}>
			<div className={classes.chatPapper}>
				<Grid container spacing={0} style={{ height: "100%" }}>
					<Grid item xs={4} className={classes.contactsWrapper}>
						<TicketsManager />
					</Grid>
					<Grid item xs={8} className={classes.messagesWrapper}>
						{ticketId ? (
							<>
								<Ticket />
							</>
						) : (
							<Paper elevation={0} className={classes.welcomeMsg}>
								<span>{i18n.t("chat.noTicketMessage")}</span>
							</Paper>
						)}
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default TicketsCustom;
